import { Title } from "react-head";
import { DefaultButton } from "../../../common/components/button/defaultButton/DefaultButton";
import { PreReservationFormFields } from "../../../common/preReservationForms/PreReservationFormFields";
import { useFillClientFormPage } from "./hooks/useFillClientFormPage";
import styles from "./FillClientFormPage.module.scss";

/**
 * A form staff emailed to a client, opened from the email's link at /fill-form/:token on the
 * studio's own domain. Rendered standalone — no app chrome, no studio picker, no login —
 * because the client is often not logged in, or has no password yet.
 */
export const FillClientFormPage = () => {
  const {
    view,
    studioName,
    formName,
    completedOnText,
    segments,
    contextValues,
    answers,
    setAnswer,
    isInvalid,
    showMissingError,
    isSubmitting,
    submit,
  } = useFillClientFormPage();

  if (view === "loading") {
    return <div className={styles.root} />;
  }

  const message: Record<Exclude<typeof view, "loading" | "form">, string> = {
    submitted: "Благодарим Ви! Формата беше изпратена успешно.",
    completed: completedOnText
      ? `Формата вече е попълнена (${completedOnText}). Благодарим Ви!`
      : "Формата вече е попълнена. Благодарим Ви!",
    expired:
      "Линкът към формата е изтекъл. Свържете се с обекта, за да Ви я изпрати отново.",
    unavailable: "Тази форма вече не е налична. Свържете се с обекта, ако имате въпроси.",
    invalid: "Линкът към формата е невалиден. Проверете дали сте го отворили изцяло от имейла.",
  };

  return (
    <div className={styles.root}>
      <Title>{formName || "Попълване на форма"}</Title>

      <div className={styles.root_content}>
        <div className={styles.root_panel}>
          {studioName && <div className={styles.root_studio}>{studioName}</div>}
          {formName && <h1 className={styles.root_title}>{formName}</h1>}

          {view === "form" ? (
            <>
              <div className={styles.root_body}>
                <PreReservationFormFields
                  segments={segments}
                  contextValues={contextValues}
                  answers={answers}
                  onAnswerChange={setAnswer}
                  isInvalid={isInvalid}
                />
              </div>

              {showMissingError && (
                <div className={styles.root_error}>Моля попълнете всички полета.</div>
              )}

              <div className={styles.root_actions}>
                <DefaultButton
                  label="Изпрати"
                  width="100%"
                  loading={isSubmitting}
                  disabled={isSubmitting}
                  onClick={submit}
                />
              </div>
            </>
          ) : (
            <p className={styles.root_message}>{message[view]}</p>
          )}
        </div>
      </div>
    </div>
  );
};
